module.exports = {"429004001":"沙嘴街道","429004002":"干河街道","429004003":"龙华山","429004100":"郑场镇","429004101":"毛嘴镇","429004102":"豆河镇","429004103":"三伏潭镇","429004104":"胡场镇","429004105":"长倘口镇","429004106":"西流河镇","429004107":"沙湖镇","429004108":"杨林尾镇","429004109":"彭场镇","429004110":"张沟镇","429004111":"郭河镇","429004112":"沔城回族镇","429004113":"通海口镇","429004114":"陈场镇","429004400":"工业园区","429004401":"九合垸原种场","429004402":"沙湖原种场","429004404":"五湖渔场","429004405":"赵西垸林场","429004407":"畜禽良种场","429004408":"排湖风景区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/429004.json
// module id = 1648
// module chunks = 0